import { EditableContent } from '../../edit/EditableContent';
import { pickBlockField } from '../../lib/localized';
import { parseLabeledLines } from '../../lib/parseLabeledLines';
import type { BlockRenderProps } from '../../types';

export function LiveTapListSync({
  block,
  locale,
  isActive,
  activeEditTarget,
  editable,
}: BlockRenderProps) {
  const sectionTitle = pickBlockField(block.content, 'sectionTitle', locale);
  const supporting = pickBlockField(block.content, 'supporting', locale);
  const tapsRaw = pickBlockField(block.content, 'taps', locale);
  const taps = parseLabeledLines(tapsRaw);
  const target = isActive ? activeEditTarget : null;

  return (
    <section
      className={['ws-tap-list', isActive ? 'ws-block--active' : ''].filter(Boolean).join(' ')}
      data-block-id={block.blockId}
      data-component={block.componentType}
      id="taps"
    >
      <div className="ws-tap-list__inner">
        <EditableContent
          as="h2"
          fieldKey="sectionTitle"
          editable={editable}
          activeEditTarget={target}
          className="ws-tap-list__title"
        >
          {sectionTitle}
        </EditableContent>
        {supporting || editable ? (
          <EditableContent
            fieldKey="supporting"
            editable={editable}
            activeEditTarget={target}
            className="ws-tap-list__supporting"
          >
            {supporting}
          </EditableContent>
        ) : null}
        {editable ? (
          <EditableContent
            fieldKey="taps"
            editable={editable}
            activeEditTarget={target}
            className="ws-tap-list__editor"
          >
            {tapsRaw}
          </EditableContent>
        ) : (
          <ol className="ws-tap-list__list">
            {taps.map((tap, index) => (
              <li key={`${tap.label}-${index}`} className="ws-tap-list__item">
                <span className="ws-tap-list__index">{String(index + 1).padStart(2, '0')}</span>
                <span className="ws-tap-list__name">{tap.label}</span>
                {tap.meta ? <span className="ws-tap-list__meta">{tap.meta}</span> : null}
              </li>
            ))}
          </ol>
        )}
      </div>
    </section>
  );
}
